import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import {
    UpdateDailyTransferRideBody,
    DailyTransferRideResponse,
    updateDailyTransferRide,
    CreateDailyTransferRideBody,
    createDailyTransferRide,
    deleteDailyTransferRide,
} from '../../services/apiSLTP/dailyReports/dailyTransfersRides';

type UseUpdateDailyTransferRideMutationOptions = MutationOptions<
    DailyTransferRideResponse,
    Error,
    { DailyTransferRideId: string; data: UpdateDailyTransferRideBody }
>;

export const useUpdateDailyTransferRideMutation = (options?: UseUpdateDailyTransferRideMutationOptions) => {
    const DailyTransferRideMutation: MutationFunction<
        DailyTransferRideResponse,
        { DailyTransferRideId: string; data: UpdateDailyTransferRideBody }
    > = async ({ DailyTransferRideId, data }) => {
        try {
            const response: DailyTransferRideResponse = await updateDailyTransferRide(DailyTransferRideId, data);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during DailyTransferRide');
        }
    };

    return useMutation(DailyTransferRideMutation, options);
};

type UseCreateDailyTransferRideMutationOptions = MutationOptions<DailyTransferRideResponse, Error, CreateDailyTransferRideBody>;

export const useCreateDailyTransferRideMutation = (options?: UseCreateDailyTransferRideMutationOptions) => {
    const DailyTransferRideMutation: MutationFunction<DailyTransferRideResponse, CreateDailyTransferRideBody> = async (data) => {
        try {
            const response: DailyTransferRideResponse = await createDailyTransferRide(data);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during DailyTransferRide');
        }
    };

    return useMutation(DailyTransferRideMutation, options);
};

type UseDeleteDailyTransferRideMutationOptions = MutationOptions<DailyTransferRideResponse, Error, string>;

export const useDeleteDailyTransferRideMutation = (options?: UseDeleteDailyTransferRideMutationOptions) => {
    const deleteMutation: MutationFunction<DailyTransferRideResponse, string> = async (id) => {
        try {
            return await deleteDailyTransferRide(id);
        } catch (error) {
            throw new Error('An unexpected error occurred while deleting the daily transfer ride');
        }
    };

    return useMutation(deleteMutation, options);
};
